import { endpoints } from '../Constants';
import { authHeader, toQueryStringURL } from '../Helpers';
import handleResponse from './helpers';

// Product image suggestions: images configured on similarly named products in our database.
function search({ q, page = 1, pageSize = 12 }) {
	const url = toQueryStringURL(endpoints.PRODUCT_IMAGE_SUGGESTIONS, {
		q,
		page,
		pageSize,
	});
	return fetch(url, {
		method: 'GET',
		headers: {
			...authHeader(),
		},
	}).then(handleResponse);
}

// One suggestion (by product id) downloaded by the backend: { id, title, dataUrl }
function fetchImage(id) {
	const url = toQueryStringURL(`${endpoints.PRODUCT_IMAGE_SUGGESTIONS}/fetch`, {
		id,
	});
	return fetch(url, {
		method: 'GET',
		headers: {
			...authHeader(),
		},
	}).then(handleResponse);
}

const productImageSuggestServices = {
	search,
	fetchImage,
};

export default productImageSuggestServices;
